import { Box, Typography } from '@mui/material'

import React from 'react'

interface FlexBoxHelperProps {
  header?: React.ReactNode
  items: Array<{
    label: string
    value: string | number | boolean | null | undefined
  }>
}

export function FlexBoxHelper({ header, items }: FlexBoxHelperProps) {
  return (
    <Box data-testid="flex-box-helper">
      {header && (
        <Typography variant="h6" gutterBottom>
          {header}
        </Typography>
      )}
      <Box display="flex" flexDirection="column" gap={1}>
        {items.map((item, index) => (
          <Box key={index} display="flex" gap={2}>
            <Typography variant="body2" fontWeight="medium" minWidth={120}>
              {item.label}:
            </Typography>
            <Typography variant="body2">
              {item.value === null || item.value === undefined
                ? 'N/A'
                : String(item.value)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
